{
  "dashboard": {
    "place": {
      "inShift": "اکنون در {{clinic}} · تا {{end}}",
      "between": "شیفت بعدی: {{clinic}} · {{start}}",
      "beforeFirst": "امروز: {{clinic}} از {{start}}",
      "done": "شیفت امروز تمام شد · {{clinic}}",
      "overlap": "هم‌زمان در {{count}} مطب",
      "noShiftToday": "برای امروز ساعت حضور ثبت نشده",
      "noShiftDay": "برای این روز ساعت حضور ثبت نشده",
      "noShiftHint": "ساعات حضور را کلینیک ثبت می‌کند",
      "otherDay": "{{weekday}}: {{clinic}} {{hours}}",
      "more": "و {{count}} مطب دیگر",
      "aria": "محل کار طبق برنامهٔ حضور"
    },
    "stats": {
      "total": "نوبت",
      "waiting": "منتظر",
      "completed": "انجام",
      "cancelled": "لغو",
      "aria": "{{total}} نوبت، {{waiting}} در انتظار، {{completed}} ویزیت‌شده، {{cancelled}} لغو‌شده",
      "share": "سهم: {{amount}}",
      "shareNoFigure": "سهم"
    },
    "week": {
      "title": "انتخاب روز",
      "thisWeek": "این هفته",
      "nextWeek": "هفتهٔ بعد",
      "prevWeek": "هفتهٔ قبل",
      "range": "{{from}} تا {{to}}",
      "fullCalendar": "تقویم کامل",
      "backToWeek": "بازگشت به هفته",
      "countAria": "{{count}} نوبت"
    },
    "clinic": {
      "auto": "خودکار — طبق برنامهٔ حضور",
      "autoSub": "مطبی که برنامهٔ حضور برای این روز نشان می‌دهد",
      "autoBadge": "خودکار"
    },
    "book": {
      "open": "نوبت جدید",
      "title": "ثبت نوبت",
      "clinic": "کلینیک",
      "patient": "بیمار",
      "searchLabel": "جست‌وجوی بیمار",
      "searchPlaceholder": "نام، شماره تماس یا کد ملی",
      "searchHint": "دست‌کم دو حرف وارد کنید.",
      "noMatch": "بیماری با این مشخصات در فهرست شما نیست.",
      "truncated": "فقط {{count}} نتیجهٔ نخست نمایش داده شد؛ دقیق‌تر جست‌وجو کنید.",
      "newPatient": "بیمار جدید",
      "pickExisting": "انتخاب از بیماران",
      "change": "تغییر",
      "name": "نام و نام خانوادگی",
      "phone": "شماره همراه",
      "nationalId": "کد ملی (اختیاری)",
      "when": "تاریخ و ساعت",
      "duration": "مدت نوبت",
      "minutes": "{{count}} دقیقه",
      "note": "یادداشت (اختیاری)",
      "submit": "ثبت نوبت",
      "submitRequest": "ارسال برای تأیید کلینیک",
      "readOnlyTitle": "فقط‌خواندنی — اشتراک کلینیک به پایان رسیده",
      "readOnly": "اشتراک این کلینیک به پایان رسیده و پنل آن فقط‌خواندنی است؛ تا کلینیک اشتراکش را تمدید نکند نمی‌توان در آن نوبت ثبت یا جابه‌جا کرد. نوبت در کلینیک‌های دیگرتان آزاد است.",
      "readOnlyOption": "{{name}} (فقط‌خواندنی)",
      "needsApprovalTitle": "نیازمند تأیید کلینیک",
      "needsApproval": "نوبت‌هایی که در این کلینیک ثبت می‌کنید پس از تأیید پذیرش نهایی می‌شوند و تا آن زمان «در انتظار تأیید کلینیک» می‌مانند.",
      "booked": "نوبت ثبت شد.",
      "requested": "نوبت برای تأیید به کلینیک ارسال شد.",
      "loadFailed": "فهرست کلینیک‌ها بارگذاری نشد.",
      "noClinic": "در حال حاضر در هیچ کلینیکی امکان ثبت نوبت ندارید.",
      "searchFailed": "جست‌وجوی بیمار انجام نشد.",
      "modeFirstDay": "اولین نوبت این روز",
      "modeFirstToday": "اولین نوبت امروز",
      "modeManual": "انتخاب دستی",
      "showTimeOptions": "تغییر روز یا روش انتخاب زمان",
      "hideTimeOptions": "بستن گزینه‌های زمان",
      "noneLeftToday": "نوبت خالی دیگری برای امروز باقی نمانده است.",
      "finding": "در حال یافتن نزدیک‌ترین نوبت…",
      "bookThisOne": "همین را ثبت کن",
      "firstFree": "اولین نوبت خالی",
      "exactAtBooking": "نوبت دقیق هنگام ثبت نهایی می‌شود.",
      "firstSlotFailed": "یافتن اولین نوبت خالی با خطا مواجه شد. می‌توانید زمان را دستی انتخاب کنید.",
      "lessOptions": "بستن گزینه‌های بیشتر",
      "typeInPerson": "حضوری",
      "typeOnline": "غیرحضوری",
      "submitFirst": "ثبت اولین نوبت",
      "walkIn": "خارج از نوبت همین الان",
      "walkInOff": "بیمار همین حالا حاضر است؛ بدون ساعت به صف امروز شما اضافه شود.",
      "walkInOn": "بدون ساعت ثبت می‌شود و بیمار همین حالا به صف امروز شما اضافه می‌شود.",
      "walkInOnShort": "بدون ساعت؛ به صف امروز اضافه می‌شود.",
      "walkInLead": "امروز نوبت خالی ندارید؛ بیمار بدون ساعت، همین حالا به صف امروز شما اضافه شود.",
      "walkInLeadShort": "بدون ساعت، به صف امروز.",
      "walkInNoGrant": "در این کلینیک نوبت‌های شما با تأیید پذیرش ثبت می‌شود؛ بیمار حاضر را پذیرش کلینیک خارج از نوبت ثبت می‌کند.",
      "walkInNoGrantShort": "در این کلینیک فقط پذیرش می‌تواند خارج از نوبت ثبت کند.",
      "alreadyOpen": {
        "scheduled": "این بیمار امروز نوبت دیگری هم دارد که هنوز نیامده است.",
        "arrived": "این بیمار همین حالا در صف امروز است؛ نوبت دوم لازم است؟",
        "in_visit": "این بیمار همین حالا در حال ویزیت است؛ نوبت دوم لازم است؟"
      },
      "submitWalkIn": "ثبت و افزودن به صف",
      "walkInBooked": "بیمار به صف امروز اضافه شد.",
      "mode": "روش انتخاب زمان",
      "day": "روز",
      "visitType": "نوع ویزیت",
      "moreOptions": "گزینه‌های بیشتر (نوع ویزیت، مدت، یادداشت)",
      "noneThisDay": "در این روز نوبت خالی ندارید.",
      "nextIs": "نزدیک‌ترین نوبت خالی شما:",
      "noneIn30Days": "در ۳۰ روز آینده هم نوبت خالی یافت نشد.",
      "slotAt": "{{date}}، ساعت {{time}}",
      "errors": {
        "clinic": "کلینیک را انتخاب کنید.",
        "patient": "بیمار را انتخاب کنید.",
        "name": "نام بیمار را وارد کنید.",
        "phone": "شمارهٔ همراه معتبر نیست.",
        "nationalId": "کد ملی معتبر نیست.",
        "when": "تاریخ و ساعت نوبت را وارد کنید.",
        "past": "این زمان گذشته است.",
        "noSlot": "در این روز نوبت خالی نیست؛ روز دیگری انتخاب کنید یا زمان را دستی وارد کنید.",
        "phoneShared": "این شماره پرونده‌های دیگری دارد؛ یکی را انتخاب کنید یا «بیمار جدید با همین شماره» را بزنید."
      },
      "searchPickClinic": "برای جست‌وجوی بیمار، ابتدا کلینیک را انتخاب کنید.",
      "phoneCandidates": {
        "title": "این شماره قبلاً برای {{count}} پرونده ثبت شده است",
        "hint": "بیمار مقابل شما یکی از این‌هاست؟ انتخابش کنید. اگر فرد دیگری با همین شماره است (مثلاً عضو دیگر خانواده)، «بیمار جدید با همین شماره» را بزنید.",
        "choose": "انتخاب",
        "sharedNote": "بیمار جدید با شماره‌ای ثبت می‌شود که پرونده‌های دیگری هم دارد.",
        "showAgain": "نمایش پرونده‌ها",
        "inClinic": "در فهرست این کلینیک",
        "conflictOnSubmit": "این شماره هم‌اکنون برای پرونده‌ای ثبت شده است؛ فهرست را بررسی کنید.",
        "lookupFailed": "بررسی پرونده‌های این شماره ممکن نشد. دوباره تلاش کنید.",
        "checking": "در حال بررسی پرونده‌های این شماره…",
        "checkFailed": "بررسی پرونده‌های این شماره ممکن نشد؛ هنگام ثبت نوبت دوباره بررسی می‌شود."
      }
    },
    "phones": {
      "more": "{{count}} شمارهٔ دیگر",
      "otherLine": "{{relation}}: {{phone}}"
    },
    "withdraw": {
      "action": "لغو درخواست",
      "title": "لغو درخواست نوبت",
      "message": "درخواست نوبت {{name}} لغو شود؟ این درخواست از فهرست کلینیک حذف می‌شود.",
      "confirm": "لغو درخواست",
      "keep": "انصراف",
      "failed": "لغو درخواست انجام نشد."
    },
    "reschedule": {
      "current": "زمان فعلی: {{when}}",
      "newTime": "زمان جدید",
      "hint": "نوبت جابه‌جا می‌شود؛ لغو و دوباره ثبت نمی‌شود، پس فاکتور و پرداخت آن سر جای خود می‌ماند.",
      "moved": "نوبت به {{when}} منتقل شد."
    },
    "edit": {
      "untimedCurrent": "خارج از نوبت — هنوز ساعتی ندارد",
      "setTimeHint": "ساعت این نوبت را تعیین کنید؛ پیامکی برای بیمار فرستاده نمی‌شود.",
      "action": "ویرایش نوبت",
      "title": "ویرایش نوبت",
      "submit": "ذخیرهٔ تغییرات",
      "type": "نوع ویزیت",
      "inPerson": "حضوری",
      "online": "آنلاین",
      "typeHint": "فقط نوع ویزیت عوض می‌شود؛ هزینهٔ ویزیت همان‌طور که ثبت شده می‌ماند.",
      "typeLocked": {
        "over": "این ویزیت به پایان رسیده و نوع آن دیگر تغییر نمی‌کند.",
        "notConfigured": "ویزیت آنلاین در این سامانه فعال نیست."
      },
      "timeLocked": {
        "status": "فقط نوبتی که هنوز در انتظار مراجعه است جابه‌جا می‌شود؛ بیمار این نوبت حاضر شده یا ویزیتش آغاز شده است.",
        "grant": "در این کلینیک نوبت‌های شما با تأیید پذیرش ثبت می‌شود؛ جابه‌جایی این نوبت را به پذیرش کلینیک بسپارید.",
        "untimed": "این نوبت «خارج از نوبت» است و ساعتی ندارد که تغییر کند."
      },
      "note": "یادداشت نوبت"
    },
    "rowOps": {
      "more": "عملیات بیشتر برای {{name}}",
      "next": "نفر بعدی",
      "backToRoom": "بازگشت به مطب",
      "note": "یادداشت نوبت",
      "nextAppt": "نوبت بعدی",
      "noShow": "عدم‌حضور",
      "cancel": "لغو نوبت",
      "cancelled": "نوبت {{name}} لغو شد.",
      "cancelTitle": "لغو نوبت",
      "cancelMessage": "نوبت {{name}} در ساعت {{time}} لغو می‌شود. این کار برگشت‌پذیر نیست.",
      "cancelConfirm": "بله، نوبت لغو شود",
      "noShowTitle": "ثبت عدم‌حضور",
      "noShowMessage": "برای نوبت {{name}} در ساعت {{time}} عدم‌حضور ثبت می‌شود.",
      "noShowConfirm": "ثبت عدم‌حضور",
      "noteTitle": "یادداشت نوبت",
      "noteLabel": "یادداشت برای نوبت {{name}}",
      "noteHint": "پذیرش کلینیک هم این یادداشت را می‌بیند. خالی بگذارید تا پاک شود.",
      "noteSave": "ذخیرهٔ یادداشت",
      "errors": {
        "hasPayment": "برای این نوبت پرداخت ثبت شده است؛ لغو آن با پذیرش کلینیک است.",
        "needsGrant": "در این کلینیک لغو نوبت و ثبت عدم‌حضور با پذیرش کلینیک است.",
        "paymentCheck": "وضعیت پرداخت این نوبت بررسی نشد؛ دوباره تلاش کنید.",
        "readOnly": "اشتراک این کلینیک به پایان رسیده و پنل آن فقط‌خواندنی است؛ این تغییر تا تمدید اشتراک انجام نمی‌شود.",
        "gone": "این نوبت دیگر وجود ندارد؛ فهرست تازه شد.",
        "next": "تنظیم نفر بعدی انجام نشد.",
        "cancel": "لغو نوبت انجام نشد.",
        "noShow": "ثبت عدم‌حضور انجام نشد.",
        "note": "ذخیرهٔ یادداشت انجام نشد."
      }
    }
  },
  "nav": {
    "mobile": {
      "more": "بیشتر",
      "moreTitle": "بیشتر",
      "account": "حساب کاربری",
      "sections": "بخش‌ها",
      "balance": "موجودی {{coin}}"
    }
  }
}
